export const freeRoutes = ['/about', '/privacy', '/help', '/terms', '/apps', '/support', '/company'];

export function handleRouteChange(route, loggedIn) {

  //replacing the previous logic with a more robust one that checks if the route starts with any of the free routes
  let startsWithSlashAnyFreeRoute = freeRoutes.some((freeRoute) => route.includes(freeRoute));

  if (!loggedIn && /* !freeRoutes.includes(route) &&  */!startsWithSlashAnyFreeRoute) {
    return '/';
  } else if (loggedIn && route === '/') {
    return '/home';
  } else {
    return route;
  }
}